import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.PullQBooksBudgetButton', {
    syncSuccessful: 'Budget synchronisation with QuickBooks Online is enabled',
});
